export { DesignCard } from './DesignCard';
export type { DesignCardProps } from './DesignCard';
